"use strict";

exports.__esModule = true;
exports.findScene = findScene;
exports.initData = initData;
exports.initSelected = initSelected;
exports.initSelected2 = initSelected2;
exports.getCurrent = getCurrent;
exports.getScene = getScene;
exports._urlSplicing = void 0;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _urlSplicing = function _urlSplicing(uri, prefix, suffix) {
  if (uri === void 0) {
    uri = "";
  }

  var exclude = ["http://", "https://", "Custom-App://", "file://"];

  for (var i = 0; i < exclude.length; i++) {
    var row = exclude[i];

    if (uri.indexOf(row) === 0) {
      return uri;
    }
  }

  if (window.baseUrl) {
    return "" + window.baseUrl + uri;
  }

  return "" + prefix + uri;
};

exports._urlSplicing = _urlSplicing;

function findScene(scenes, categoryId) {
  var effectiveScene = [];
  var sceneIds = [];
  scenes.forEach(function (scene) {
    if (scene.categoryId == categoryId) {
      sceneIds.push(scene.id);

      if (scene.showThumb) {
        var temp = _extends({}, scene); // temp.id = temp.id;


        temp.sceneIds = [temp.id];
        effectiveScene.push(temp);
      }
    }
  });
  return {
    effectiveScene: effectiveScene,
    sceneIds: sceneIds
  };
}

function initData(value, scenes) {
  var data = [];
  var sceneIds = [];
  value.forEach(function (item) {
    var id = item.id,
        name = item.name,
        children = item.children;

    if (children) {
      var res = initData(children, scenes);

      if (res.data.length > 0) {
        data.push({
          id: id,
          name: name || id,
          children: res.data,
          sceneIds: res.sceneIds
        });
      }

      sceneIds = [].concat(sceneIds, res.sceneIds);
    } else {
      var _res = findScene(scenes, id);

      if (_res.effectiveScene.length > 0) {
        data.push({
          id: id,
          name: name || id,
          children: _res.effectiveScene,
          sceneIds: _res.sceneIds
        });
      }

      sceneIds = [].concat(sceneIds, _res.sceneIds);
    }
  });
  return {
    data: data,
    sceneIds: sceneIds
  };
}

function initSelected(category, scenesId) {
  var selected = [];
  if (!category) return selected;
  var selectedItem;

  for (var i = 0; i < category.length; i++) {
    var item = category[i];

    if (item.sceneIds.indexOf(scenesId) >= 0) {
      selectedItem = item;
      break;
    }
  }

  if (selectedItem || category.length > 0 && category[0].children) {
    if (!selectedItem) {
      selectedItem = category[0];
    }

    selected.push(selectedItem.id);
    var temp = initSelected(selectedItem.children, scenesId);
    selected = [].concat(selected, temp);
  }

  return selected;
}

function initSelected2(category, scenesId) {
  var selected = [];
  if (!category) return selected;
  var selectedItem;

  for (var i = 0; i < category.length; i++) {
    var item = category[i];

    if (item.sceneIds.indexOf(scenesId) >= 0) {
      selectedItem = item;
      break;
    }
  }

  if (selectedItem || category.length > 0 && category[0].children) {
    if (!selectedItem) {
      selectedItem = category[0];
    }

    selected.push(selectedItem.id);
    var temp = initSelected2(selectedItem.children, scenesId);
    selected = [].concat(selected, temp);
  } else {
    selected.push(scenesId);
  }

  return selected;
}

function getCurrent(menu, id) {
  var current;

  for (var i = 0; i < menu.length; i++) {
    var item = menu[i];

    if (item.id === id) {
      current = item;
      break;
    }
  }

  return current;
}

function getScene(scenes, categoryId) {
  return scenes.find(function (scene) {
    return scene.categoryId == categoryId;
  });
}